import mechanicImg from "../assets/mechanic1.jpg";
//for mechanic photo

// src/pages/About.js

import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Grid,
  Paper,
  Avatar,
  Link as MuiLink,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { motion, animate, stagger } from "motion/react";

import MenuIcon from "@mui/icons-material/Menu";
import { Close } from "@mui/icons-material";

import Header from "../components/header";
import Footer from "../components/footer";
import dividerImg from "../assets/divider.png";

const About = () => {
  const theme = useTheme();
  const [selectedMember, setSelectedMember] = useState(null);
  const [viewMember, setViewMember] = useState(false);

  function toggleModal(member = null) {
    const dash = document.getElementById("about");
    setSelectedMember(member);
    if (!viewMember) {
      setViewMember(true);
      dash.classList.add("grey-out");
    } else {
      setViewMember(false);
      dash.classList.remove("grey-out");
    }
  }

  return (
    <>
      <Box
        id="about"
        sx={{ bgcolor: "#fff", color: "#000", minHeight: "100vh" }}
      >
        <Header />

        {/* Banner Image */}
        <Box sx={{ display: "flex", position: "relative" }}>
          <motion.div
            className="about__image"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ease: "easeOut", duration: 2 }}
          >
            <div className="img__shader"></div>
          </motion.div>
        </Box>

        {/* About / Mission / Vision */}
        <motion.div
          className="about-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, ease: "easeOut", duration: 2 }}
        >
          
            <Box className="about-card" sx={{ my: "24px" }}>
              <h3>About Us</h3>
              <p>
                Autoshops.com is a tech driven platform built for car owners and
                autoshops alike. We aim to revolutionize the car repair
                experience by fostering a network rooted in accountability,
                digital innovation, and car owner's trust. Whether you're
                scheduling a repair or managing your auto shop, AutoShops.com is
                here to streamline the process and build lasting confidence in
                every service.
              </p>
            </Box>
            <Box className="about-card" sx={{ my: "24px" }}>
              <h3>Our Mission</h3>
              <p>
                At AutoShops.com, our mission is to bring trust, transparency,
                and convenience to the auto repair industry by connecting car
                owners with verified, honest autoshops through a seamless
                digital experience. We empower customers to make informed
                decisions with real-time service requests, transparent pricing,
                and OBD2-based diagnostics — all in one platform.
              </p>
            </Box>
            <Box className="about-card" sx={{ my: "24px" }}>
              <h3>Our Vision</h3>
              <p>
                We envision a future where car maintenance is stress-free,
                affordable, and fully digitized. Our goal is to eliminate
                uncertainty and hidden costs in auto repair by giving users
                control over their vehicle data, service history, and autoshop
                relationships — while equipping autoshops with tools to grow
                their business and build lasting trust.
              </p>
            </Box>
        </motion.div>

        <Footer />
      </Box>

    </>
  );
};

export default About;
